import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Logger } from '@app/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoSupplierSelectComponent');

@Component({
  selector: 'app-kendo-supplier-select',
  templateUrl: './kendo-supplier-select.component.html',
  styleUrls: ['./kendo-supplier-select.component.scss'],
})
export class KendoSupplierSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'supplier_id';

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      supplier_id: [null],
      supplier: [null],
    });

    const supplier = this.getObjectFromStorage(this.field, 'suppliers');

    if (supplier) {
      setTimeout(() => {
        this.form.patchValue({
          supplier: supplier,
          supplier_id: supplier.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'suppliers');

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
